module.exports = "<div ng-if=\"Ctrl.options.container == 'accordion'\">\n\t<p> <strong>{{ Ctrl.input.label | translate}}</strong> </p>\n\t<div ng-bind-html=\"Ctrl.input.data[0].value\"></div>\n</div>\n\n<div class=\"row\" ng-if=\"Ctrl.options.container == 'panel'\">\n\t<div class=\"col-sm-5 font-bold\" ng-class=\"{'m-t-sm': !$first}\">{{ Ctrl.input.label | translate }}</div>\n\t<div class=\"col-sm-7 text-muted\" ng-class=\"{'m-t-sm': !$first}\">\n\t\t<span ng-repeat=\"val in Ctrl.input.data\">\n\t\t\t{{ val.value }}\n\t\t</span>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/input-form-view/templates/select-view.html
// module id = 310
// module chunks = 0